import { memo } from 'react';
import { CashStoresPage } from './CashStoresPage';

/** Gallery entry: barcode drawer open with the amount-mismatch alert visible. */
export const CashStoresAmountMismatchPage = memo(() => (
  <CashStoresPage preview="amount-mismatch" />
));
